import { LayoutGrid, List } from 'lucide-react';

import { cn } from '@sandtech-hub-monorepo/ui-kit';

import { plural } from '../../../utils/plural';

export type CatalogueView = 'grid' | 'list';

interface Props {
  /** How many PROGRAMS survived the filters - the grid below lists programs,
   *  not the courses inside them. */
  count: number;
  view: CatalogueView;
  onViewChange: (view: CatalogueView) => void;
}

/*
 * Category/Duration/Level filters are deliberately not here: `category`,
 * `hours` and `level` are always undefined today (see data/programs.ts),
 * so a filter bar for them would be pure decoration with nothing to filter.
 * Re-add once a backend field actually populates one of them.
 */
export const CatalogueFilterBar = ({ count, view, onViewChange }: Props) => (
  <div className="flex items-center justify-end gap-4">
    <span className="text-sm text-muted-foreground">
      {count} {plural(count, 'program', 'programs')}
    </span>
    <div className="flex items-center rounded-md border border-border">
      <button
        type="button"
        aria-label="Grid view"
        onClick={() => onViewChange('grid')}
        className={cn(
          'flex h-9 w-9 items-center justify-center rounded-l-md',
          view === 'grid' ? 'bg-muted text-primary' : 'text-muted-foreground'
        )}
      >
        <LayoutGrid className="h-5 w-5" />
      </button>
      <button
        type="button"
        aria-label="List view"
        onClick={() => onViewChange('list')}
        className={cn(
          'flex h-9 w-9 items-center justify-center rounded-r-md',
          view === 'list' ? 'bg-muted text-primary' : 'text-muted-foreground'
        )}
      >
        <List className="h-5 w-5" />
      </button>
    </div>
  </div>
);
